import Header, { ICobrandedLogProps } from "../global/components/Header";
import Footer from "../global/components/Footer";
import IlpRouter from "./components/IlpRouter";
import { IlpProvider } from "./contexts/IlpContext";
import { AuthenticationProvider } from "../global/contexts/AuthenticationContext";
import { AuthorizationProvider } from "../global/contexts/AuthorizationContext";
import { DuesSponsoredOrgProvider } from "../global/contexts/DuesSponsoredOrgContext";
import cobrandedLogo from "./images/PediaLinkLogo.png";
import { UserInfoProvider } from "../global/contexts/UserInfoContext";

//This component sets up the Ilp application by calling the Header,
//AuthenticationProvider, AuthorizationProvider, IlpProvider, IlpRouter, and Footer components.
export default function IlpApp() {
    console.log("env: " + process.env.NODE_ENV);
    const cobrandedLogProps: ICobrandedLogProps = {
        source: cobrandedLogo,
        url: process.env.REACT_APP_ILP_COBRANDED_URL!,
        text: "PediaLink Logo",
    };

    return (
        <>
            <Header
                message={"Individualized Learning Plan"}
                cobrandedLogProps={cobrandedLogProps}
            />
            <AuthenticationProvider>
                <AuthorizationProvider>
                    <UserInfoProvider>
                        <DuesSponsoredOrgProvider>
                            <IlpProvider>
                                <IlpRouter />
                            </IlpProvider>
                        </DuesSponsoredOrgProvider>
                    </UserInfoProvider>
                </AuthorizationProvider>
            </AuthenticationProvider>
        </>
    );
}
